import { ILastMeasureDataAutocompleteResponse, IMeasureOption } from "../../interfaces";

type TMeasureSelectionSource = Pick<IMeasureOption, "idMeasure" | "measureDate">;

export const getMeasureSelectionKey = ({ idMeasure, measureDate }: TMeasureSelectionSource): string | null =>
  idMeasure != null && measureDate ? `${idMeasure}|${measureDate}` : null;

export const parseIdMeasureQueryParam = (value: string | null): number[] =>
  value
    ? value
        .split(",")
        .map(queryValue => queryValue.trim())
        .filter(Boolean)
        .map(queryValue => Number(queryValue))
        .filter(Number.isFinite)
    : [];

export const getIdMeasureFormValue = (measureIds: number[], isOrbitSelected: boolean): number | number[] =>
  isOrbitSelected ? measureIds[0] : measureIds;

export const mergeMeasuresBySelectionKey = (
  current: ILastMeasureDataAutocompleteResponse[],
  next: ILastMeasureDataAutocompleteResponse[],
): ILastMeasureDataAutocompleteResponse[] => {
  const existingMeasureKeys = new Set(current.map(getMeasureSelectionKey));

  return [...current, ...next.filter(measure => !existingMeasureKeys.has(getMeasureSelectionKey(measure)))];
};
